<template>
  <div class="d-inline-block">
    <span v-html="classBadge(typeBadgeStatus)" />
  </div>
</template>
<script>
import i18n from '@/plugins/i18n';
export default {
  props: {
    typeBadgeStatus: {
      type: [String],
      default: null
    }
  },
  mounted() {
  },
  methods: {
    classBadge(type){
      let badge = "";
      switch (type) {
        case 'TO_RETURN':
            badge = '<span class="badge bg-danger-400"><i class="fa-solid fa-arrow-rotate-left"></i>'+ i18n.t('_statusbadge.Returned')+'</span>';
          break;
        case 'CANCELLED':
            badge = '<span class="badge bg-danger-400"><i class="fa-solid fa-circle-xmark"></i>'+ i18n.t('_statusbadge.Cancelled')+'</span>';
          break;
      }
      return badge;
    }
  }

}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/tenancy/center/BadgeStatus.vue